import { useCallback, useMemo, useEffect } from 'react';
import {
  useAppDispatch,
  useAppSelector,
} from '@store/index';
import {
  loginUser,
  registerUser,
  getCurrentUser,
  logoutUser,
  changePassword,
  checkAuth,
  clearError,
  startImpersonation, // Import impersonation actions
  stopImpersonation,
} from '@store/auth/authSlice';
import {
  LoginRequest,
  RegisterRequest,
  ChangePasswordRequest,
} from '@/types/auth.types';

let appInitialized = false;

export const useAuth = () => {
  const dispatch = useAppDispatch();

  const {
    user,
    isAuthenticated,
    loading,
    initialLoading, // Додано
    error,
    isImpersonating,
    originalUser,
    impersonationError,
  } = useAppSelector((state) => state.auth);

  // Actions
  const login = useCallback((credentials: LoginRequest) => dispatch(loginUser(credentials)), [dispatch]);
  const register = useCallback((userData: RegisterRequest) => dispatch(registerUser(userData)), [dispatch]);
  const logout = useCallback(() => {
    appInitialized = false;
    return dispatch(logoutUser());
  }, [dispatch]);
  const updatePassword = useCallback((data: ChangePasswordRequest) => dispatch(changePassword(data)), [dispatch]);
  const fetchCurrentUser = useCallback(() => dispatch(getCurrentUser()), [dispatch]);
  const clearAuthError = useCallback(() => dispatch(clearError()), [dispatch]);
  const startImpersonate = useCallback((userId: number) => dispatch(startImpersonation(userId)), [dispatch]);
  const stopImpersonate = useCallback(() => dispatch(stopImpersonation()), [dispatch]);

  // Initial check
  useEffect(() => {
    if (!appInitialized) {
        appInitialized = true;
        dispatch(checkAuth());
    }
  }, [dispatch]);

  // Derived state
  const isReady = isAuthenticated && user && !loading;

  return useMemo(() => ({
    user,
    isAuthenticated,
    loading,
    initialLoading, // Додано
    error,
    isReady,
    isImpersonating,
    originalUser,
    impersonationError,
    login,
    register,
    logout,
    updatePassword,
    fetchCurrentUser,
    clearAuthError,
    startImpersonate,
    stopImpersonate,
  }), [
    user,
    isAuthenticated,
    loading,
    initialLoading, // Додано
    error,
    isReady,
    isImpersonating,
    originalUser,
    impersonationError,
    login,
    register,
    logout,
    updatePassword,
    fetchCurrentUser,
    clearAuthError,
    startImpersonate,
    stopImpersonate,
  ]);
};
